var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8 16c3.666 0 6.638-2.786 6.638-6.223 0-3.944-4.403-8.128-6.037-9.545a.91.91 0 0 0-1.202 0c-1.634 1.417-6.037 5.6-6.037 9.545C1.362 13.214 4.334 16 8 16m0-2a2.813 2.813 0 0 0 2.813-2.813c0-1.278-.952-2.636-2.073-3.86a1 1 0 0 0-1.48 0c-1.12 1.224-2.073 2.582-2.073 3.86A2.813 2.813 0 0 0 8 14",
    clipRule: "evenodd"
  })));
};
export { SvgFire as ReactComponent };